import { render, staticRenderFns } from "./SimulationTemplate.vue?vue&type=template&id=12840ef6&scoped=true&"
import script from "./SimulationTemplate.vue?vue&type=script&lang=js&"
export * from "./SimulationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SimulationTemplate.vue?vue&type=style&index=0&id=12840ef6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12840ef6",
  null
  
)

export default component.exports